import { render, staticRenderFns } from "./CheHua1.vue?vue&type=template&id=54b887c7&scoped=true&"
import script from "./CheHua1.vue?vue&type=script&lang=js&"
export * from "./CheHua1.vue?vue&type=script&lang=js&"
import style0 from "./CheHua1.vue?vue&type=style&index=0&id=54b887c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b887c7",
  null
  
)

export default component.exports